import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { createBrowserRouter } from "@/lib/sentry";
import { AuthProvider } from "@/hooks/useAuth";
import { routes } from "@/routes/config";

const queryClient = new QueryClient();
const router = createBrowserRouter(routes, {
	future: {
		v7_relativeSplatPath: true,
		v7_startTransition: true,
	},
});

const App = () => (
	<QueryClientProvider client={queryClient}>
		<AuthProvider>
			<TooltipProvider>
				<Toaster />
				<Sonner />
				<RouterProvider router={router} />
			</TooltipProvider>
		</AuthProvider>
	</QueryClientProvider>
);

export default App;
